import { IToken, CstNode, TokenType, } from 'chevrotain';
export var getAsTypedTuple = function () {
    var args = [];
    for (var _i = 0; _i < arguments.length; _i++) {
        args[_i] = arguments[_i];
    }
    return args;
};
// exported for convenience
export { IToken, CstNode, TokenType };
